// in src/App.js
import * as React from "react";
// import { Admin } from 'react-admin';

import { Admin, Resource } from 'react-admin';
import { GetPublicAdress } from '../src/global'

// import { PostList, PostEdit, PostCreate } from './Posts';
import jsonServerProvider from 'ra-data-json-server';
import { UserList } from './users';
// import { PostList } from './Posts';
import { FaqList } from './Pages/FaqList';
// import  News  from './TestNews';
import { BlogList } from './Pages/BlogList';
import { BlogShow } from './Pages/BlogShow';
import { ContactUs } from './Pages/ContactUs';

import PostIcon from '@material-ui/icons/Book';
import UserIcon from '@material-ui/icons/Group';

import HelpIcon from '@material-ui/icons/Help';
import CallIcon from '@material-ui/icons/Call';

import MyLayout from './MyLayout';
import { createTheme } from '@material-ui/core/styles';
import { FaEnvelope, FaRegNewspaper } from 'react-icons/fa';
import InfoIcon from '@material-ui/icons/Info';
import { AboutUs } from './Pages/AboutUs';
import { Media } from './Pages/Media';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import ReactGA from 'react-ga';
import { createBrowserHistory } from 'history';

const TRACKING_ID = "UA-5301185-1"; // YOUR_OWN_TRACKING_ID


// create the history
const history = createBrowserHistory();

// listen for a route change and record page view
history.listen(location => {
  ReactGA.pageview( location.pathname + location.search);

});

// initialize GA
ReactGA.initialize(TRACKING_ID);

// record the first pageview because listen will not be called
ReactGA.pageview(window.location.pathname);



//const dataProvider = jsonServerProvider(process.env.jsonServerProvider);
// const dataProvider = jsonServerProvider('http://fencing.lv/Fencing.Api/v1.0');
const dataProvider = jsonServerProvider(GetPublicAdress());


//const dataProvider = jsonServerProvider('https://jsonplaceholder.typicode.com');
// const App = () => <Admin dataProvider={dataProvider} />;
// <Resource name="posts" list={PostList} edit={PostEdit} create={PostCreate} icon={PostIcon}  />




const theme = createTheme({
  palette: {
    //   type: 'dark', // Switching the dark mode on is a single property value change.
  },
  sidebar: {
    // width: 220, 
    //closedWidth: 55, 
  },
  overrides: {
    RaMenuItemLink: {
      active: {
        borderLeft: '8px solid #f5681c',

        color: 'rgba(0, 0, 0, 1)',



      },
      root: {
        borderLeft: '5px solid #fff', // invisible menu when not active, to avoid scrolling the text when selecting the menu
        color: 'rgba(0, 0, 0, 0.54)'
      },
    },
    RaList: {
      main: {
        maxWidth: '900px !important',
        margin: '0 auto'
      }
    },

     RaShow: {
       main:{
         maxWidth: '900px !important',
         margin: '0 auto'
       }
     },

    MuiListItemIcon: {
      root: {
        color: "rgba(0, 0, 0, 0.7)"
        //color:"#f5681c"
      },

    }
  },

});

const App = () => (
  <Admin dataProvider={dataProvider} layout={MyLayout} theme={theme} title="fencing"   history={history} >


    <Resource name="news" options={{ label: 'Блог' }}  list={BlogList} />
    <Resource name="faq" options={{ label: 'Вопросы' }} list={FaqList} icon={HelpIcon} />
    {/* <Resource name="users" list={UserList} icon={UserIcon} /> */}
    <Resource name="contactUs" options={{ label: 'Контакты' }} list={ContactUs} icon={CallIcon} />

    <Resource  name="blog" options={{ label: 'Блог' }} show={BlogShow} />


     {/* <Resource name="media" options={{ label: 'Галерея' }} list={Media} icon={PhotoLibraryIcon} />  */}

    <Resource name="aboutUs" options={{ label: 'О Клубе' }} list={AboutUs} icon={InfoIcon} />

    {/* <Resource name="news"  list={News} icon={UserIcon} /> */}



  </Admin>
);

export default App;